import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import VendorPanCreateModalUI from './VendorPanCreateModalUI'


class VendorPanCreateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            submitted: false,
            vendorName: '',
            ifscCode: '',
            bankAccountNumber: '',
            beneficiaryName: '',
            tdsCode: '',
            state: '',
            panNumber: '',
            gstin: '',
            gstinList: null,
            tdsTypes: null,
            tdsList: [],
            stateList: [],
            vendorNameError: null,
            ifscCodeError: null,
            bankAccountNumberError: null,
            beneficiaryNameError: null,
            tdsCodeError: null,
            stateError: null,
            tdsTypeError: null,
            panNumberError: null,
            gstinError: null,
            selectedTdsType: 'goods',
        }
    }

    render() {
        let tdsTypeList = [
            { key: 'goods', value: 'Goods' },
            { key: 'services', value: 'Services' },
            { key: 'others', value: 'Others' }
        ]
        return (
            <VendorPanCreateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                createMode={this.props.createMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.onCancelClick}
                //
                vendorName={this.state.vendorName}
                onVendorNameChange={(event) => { this.setState({ vendorName: event.target.value }) }}
                vendorNameError={this.state.vendorNameError}
                setVendorNameError={(error) => { this.setState({ vendorNameError: error }) }}
                //
                ifscCode={this.state.ifscCode}
                onIfscCodeChange={(event) => { this.setState({ ifscCode: event.target.value }) }}
                ifscCodeError={this.state.ifscCodeError}
                setIfscCodeError={(error) => { this.setState({ ifscCodeError: error }) }}
                //
                bankAccountNumber={this.state.bankAccountNumber}
                onBankAccountNumberChange={(event) => { this.setState({ bankAccountNumber: event.target.value }) }}
                bankAccountNumberError={this.state.bankAccountNumberError}
                setBankAccountNumberError={(error) => { this.setState({ bankAccountNumberError: error }) }}
                //
                beneficiaryName={this.state.beneficiaryName}
                onBeneficiaryNameChange={(event) => { this.setState({ beneficiaryName: event.target.value }) }}
                beneficiaryNameError={this.state.beneficiaryNameError}
                setBeneficiaryNameError={(error) => { this.setState({ beneficiaryNameError: error }) }}
                //
                tdsCode={this.state.tdsCode}
                onTdsCodeChange={(event) => { this.setState({ tdsCode: event.target.value }) }}
                tdsCodeError={this.state.tdsCodeError}
                setTdsCodeError={(error) => { this.setState({ tdsCodeError: error }) }}
                tdsList={this.state.tdsList}
                //
                state={this.state.state}
                onStateChange={(event) => { this.setState({ state: event.target.value }) }}
                stateError={this.state.stateError}
                setStateError={(error) => { this.setState({ stateError: error }) }}
                stateList={this.state.stateList}
                //
                panNumber={this.state.panNumber}
                onPanNumberChange={(event) => { this.setState({ panNumber: event.target.value }) }}
                panNumberError={this.state.panNumberError}
                setPanNumberError={(error) => { this.setState({ panNumberError: error }) }}
                //
                gstin={this.state.gstin}
                onGstinChange={(event) => { this.setState({ gstin: event.target.value }) }}
                gstinError={this.state.gstinError}
                setGstinError={(error) => { this.setState({ gstinError: error }) }}
                gstinList={this.state.gstinList}
                //
                selectedTdsType={this.state.selectedTdsType}
                onTdsTypeChange={this.onTdsTypeChange}
                tdsTypeError={this.state.tdsTypeError}
                setTdsTypeError={(error) => { this.setState({ tdsTypeError: error }) }}
                tdsTypeList={tdsTypeList}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getTdsTypes(context)
        this.getState(context)
        Modal.setAppElement('body')
    }

    onTdsTypeChange = (event) => {
        let tdsType = event.target.value
        let tdsList = this.state.tdsTypes[tdsType].map((tds) => {
            return { key: tds.tdsCode, value: tds.description }
        })
        this.setState({ selectedTdsType: event.target.value, tdsList: tdsList })
    }

    getTdsTypes(context) {
        let cacheManager = new CacheManager({
            resource: `/api/reference/tdsTypes`,
            cacheKey: CacheKeys.TdsTypes(),
            callback: this.getTdsTypesCallback,
            ttlInSecs: 3600
        })
        cacheManager.getObject2(context)
    }

    getTdsTypesCallback = (response) => {
        let tdsList = response.goods.map((tds) => {
            return { key: tds.tdsCode, value: tds.description }
        })
        this.setState({ tdsTypes: response, tdsList: tdsList })
    }

    getState(context) {
        let cacheManager = new CacheManager({
            resource: `/api/pub/indiaStates`,
            cacheKey: CacheKeys.State(),
            callback: this.getStateCallback,
            ttlInSecs: 3600
        })
        cacheManager.getObject2(context)
    }

    getStateCallback = (response) => {
        let stateList = response.indiaStateList.map((state) => {
            return { key: state.code, value: state.name };
        });
        this.setState({ errorList: response.errorList, stateList: stateList })
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })
        if (!this.state.gstinList) {
            //get gstinList
            let context = this.props.context
            let cacheManager = new CacheManager({
                resource: `/api/su/PANs/${this.state.panNumber}/GSTNAddresses`,
                cacheKey: CacheKeys.PANGSTList(this.state.panNumber),
                callback: this.getGstListCallback,
                ttlInSecs: 0
            })
            cacheManager.getObject2(context)
            return
        }

        RestApiUtils.post(this.props.context,
            `/api/su/accounts/${this.props.account.accountId}/vendors/pan`,
            this.onSubmitCallback, {
            vendorName: this.state.vendorName,
            ifscCode: this.state.ifscCode,
            bankAccountNumber: this.state.bankAccountNumber,
            beneficiaryName: this.state.beneficiaryName,
            tdsCode: this.state.tdsCode,
            gstin: this.state.gstin,
            panNumber: this.state.panNumber,
            state: this.state.state
        });
    }
    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 2000)
        }
    }

    getGstListCallback = (response) => {
        console.log(response.gstnAddress)
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })


        if (response.errorList.length > 0) {
            this.setState({
                errorList: errorList,
                submitted: false
            })
            return
        }

        let gstinList = response.gstnAddress.map((gstin) => {
            return { key: gstin.gstin, value: gstin.gstin + '-' + gstin.stateName }
        })
        this.setState({
            successMsg: response.success,
            errorList: errorList,
            gstinList: gstinList,
            submitted: false
        })
    }

    onCancelClick = () => {
        this.setState({
            vendorName: '',
            ifscCode: '',
            bankAccountNumber: '',
            beneficiaryName: '',
            tdsCode: '',
            state: '',
            panNumber: '',
            gstin: '',
            gstinList: null,
            errorList: null,
        })
        this.props.onCancelClick()
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default VendorPanCreateModalSF
